export const urls = {
    api: {
        http: {
            development: 'http://localhost:3000',
            staging: 'https://api.staging.companyon.ch',
            production: 'https://api.companyon.ch',
        },
        webSocket: {
            development: 'ws://localhost:3000',
            staging: 'wss://api.staging.companyon.ch',
            production: 'wss://api.companyon.ch',
        },
    },
    apiInternal: {
        // Server-to-server; working around/preventing routing problems
        http: {
            development: 'http://localhost:3000',
            staging: 'http://dockerhost:12003',
            production: 'https://api.companyon.ch',
        },
        webSocket: {
            development: 'ws://localhost:3000',
            staging: 'ws://dockerhost:12003',
            production: 'wss://api.companyon.ch',
        },
    },
    uploads: {
        development: 'http://localhost:4000',
        staging: 'https://uploads.staging.companyon.ch',
        production: 'https://uploads.companyon.ch',
    },
    web: {
        customer: {
            development: 'http://localhost:5000',
            staging: 'https://staging.companyon.ch',
            production: 'https://companyon.ch',
            productionAliases: ['https://c7n.ch'],
        },
        merchant: {
            development: 'http://localhost:5001',
            staging: 'https://merchant.staging.companyon.ch',
            production: 'https://merchant.companyon.ch',
            productionAliases: ['https://m.c7n.ch', 'https://merchant.c7n.ch'],
        },
    },
};
//# sourceMappingURL=urls.js.map